var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-scroll',{attrs:{"options":{
    scrollPanel: { scrollingX: false },
  }}},[_c('a',{staticClass:"twitter-timeline",attrs:{"href":_vm.src,"data-chrome":"nofooter noborders noheader noscrollbar"}})])}
var staticRenderFns = []

export { render, staticRenderFns }